<nav class="sidebar" [class.collapsed]="sidebarService.isCollapsed()">
  <div class="sidebar-logo">
    <div class="logo-wrapper">
      <div class="logo-mark">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 2 A18 18 0 0 0 2 20 A18 18 0 0 0 20 38"
            stroke="#0d1b4b"
            stroke-width="2.5"
            fill="none"
            stroke-linecap="round"
          />
          <path
            d="M20 7 A13 13 0 0 0 7 20 A13 13 0 0 0 20 33"
            stroke="#0d1b4b"
            stroke-width="2.5"
            fill="none"
            stroke-linecap="round"
          />
          <path
            d="M20 12 A8 8 0 0 0 12 20 A8 8 0 0 0 20 28"
            stroke="#e05470"
            stroke-width="2.5"
            fill="none"
            stroke-linecap="round"
          />
          <path
            d="M20 17 A3 3 0 0 0 17 20 A3 3 0 0 0 20 23"
            stroke="#e05470"
            stroke-width="3"
            fill="none"
            stroke-linecap="round"
          />
          <path
            d="M20 2 A18 18 0 0 1 38 20"
            stroke="#e05470"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            opacity="0.4"
          />
          <path
            d="M20 7 A13 13 0 0 1 33 20"
            stroke="#e05470"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            opacity="0.3"
          />
        </svg>
      </div>
      <div class="logo-text-container">
        <span class="logo-text-top">SOUTHLAKE</span>
        <span class="logo-text-bottom">INSURANCE</span>
      </div>
    </div>
  </div>

  <div class="sidebar-scroll">
    <div class="sidebar-nav">
      <!-- 1. Dashboard -->
      <div class="nav-item-group" [class.expanded]="dashboardExpanded">
        <a
          class="nav-item group-header"
          (click)="toggleDashboard($event)"
          tabindex="0"
          (keydown.enter)="toggleDashboard($event)"
          (keydown.space)="toggleDashboard($event)"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <rect x="3" y="3" width="7" height="7" rx="1.5" />
            <rect x="14" y="3" width="7" height="7" rx="1.5" />
            <rect x="14" y="14" width="7" height="7" rx="1.5" />
            <rect x="3" y="14" width="7" height="7" rx="1.5" />
          </svg>
          <span class="nav-label">Dashboard</span>
          <svg lucideChevronDown class="arrow-icon"></svg>
        </a>

        <div class="nav-sub-items">
          <a class="nav-item sub-item" routerLink="/dashboard" routerLinkActive="active">
            <svg class="sub-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <rect x="3" y="3" width="7" height="7" rx="1.5" />
              <rect x="14" y="3" width="7" height="7" rx="1.5" />
              <rect x="14" y="14" width="7" height="7" rx="1.5" />
              <rect x="3" y="14" width="7" height="7" rx="1.5" />
            </svg>
            <span>Overview &amp; KPIs</span>
          </a>
        </div>
      </div>

      <!-- 2. Advanced Accounting -->
      @if (
        hasPermission("chart_of_accounts", "view") ||
        hasPermission("journal_entry", "view") ||
        hasPermission("test_balance", "view") ||
        hasPermission("reinsurance", "view")
      ) {
        <div class="nav-item-group" [class.expanded]="accountingExpanded">
          <a
            class="nav-item group-header"
            (click)="toggleAccounting($event)"
            tabindex="0"
            (keydown.enter)="toggleAccounting($event)"
            (keydown.space)="toggleAccounting($event)"
          >
            <svg lucideFileText class="nav-icon"></svg>
            <span class="nav-label">Advanced Accounting</span>
            <svg lucideChevronDown class="arrow-icon"></svg>
          </a>

          <div class="nav-sub-items">
            @if (hasPermission("chart_of_accounts", "view")) {
              <a class="nav-item sub-item" routerLink="/chart-of-accounts" routerLinkActive="active">
                <svg lucideMenu class="sub-nav-icon"></svg>
                <span>Chart of Accounts</span>
              </a>
            }
            @if (hasPermission("journal_entry", "view")) {
              <a class="nav-item sub-item" routerLink="/journal-entries" routerLinkActive="active">
                <svg lucideFileText class="sub-nav-icon"></svg>
                <span>Journal Entries</span>
              </a>
            }
            @if (hasPermission("test_balance", "view")) {
              <a class="nav-item sub-item" routerLink="/trial-balance" routerLinkActive="active">
                <svg lucideScale class="sub-nav-icon"></svg>
                <span>Trial Balance</span>
              </a>
            }
            @if (hasPermission("reinsurance", "view")) {
              <a class="nav-item sub-item" routerLink="/reinsurance-calculations" routerLinkActive="active">
                <svg
                  class="sub-nav-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                <span>Premium & Claims Exhibits</span>
              </a>
            }
          </div>
        </div>
      }

      <!-- 3. Config Tools / Master Data collapsible -->
      @if (
        hasPermission("mga", "view") ||
        hasPermission("class_of_business", "view") ||
        hasPermission("coverage", "view") ||
        hasPermission("state", "view") ||
        hasPermission("reinsurer", "view") ||
        hasPermission("carrier", "view") ||
        hasPermission("broker", "view") ||
        hasPermission("tpa", "view") ||
        hasPermission("product", "view") ||
        hasPermission("masters_config", "view") ||
        hasPermission("treaty_type", "view") ||
        hasPermission("gl_mapping", "view")
      ) {
        <div class="nav-item-group" [class.expanded]="mastersExpanded">
          <a
            class="nav-item group-header"
            (click)="toggleMasters($event)"
            tabindex="0"
            (keydown.enter)="toggleMasters($event)"
            (keydown.space)="toggleMasters($event)"
          >
            <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            <span class="nav-label">Config Tools</span>
            <svg lucideChevronDown class="arrow-icon"></svg>
          </a>

          <div class="nav-sub-items">
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'brokers' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg lucideUsers class="sub-nav-icon"></svg>
              <span>Brokers</span>
            </a>

            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'carriers' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7" />
              </svg>
              <span>Carriers</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'classes-of-business' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polygon points="12 2 2 7 12 12 22 7 12 2" />
                <polyline points="2 17 12 22 22 17" />
                <polyline points="2 12 12 17 22 12" />
              </svg>
              <span>Classes of Business</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'coverages' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
              </svg>
              <span>Coverages</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'document-types' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg lucideFileText class="sub-nav-icon"></svg>
              <span>Document Types</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'cost-centers' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
              </svg>
              <span>Cost Centers</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'account-types' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
              <span>Account Types</span>
            </a>
            @if (hasPermission("admin_tool", "view")) {
              <a
                class="nav-item sub-item"
                routerLink="/masters"
                [queryParams]="{ tab: 'locked-periods' }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
              >
                <svg
                  class="sub-nav-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <span>Month Close</span>
              </a>
              <a
                class="nav-item sub-item"
                routerLink="/masters"
                [queryParams]="{ tab: 'gl-mappings' }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
              >
                <svg
                  class="sub-nav-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
                <span>GL Map</span>
              </a>
            }
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'mgas' }"
              [class.active]="isMgasNavActive"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
              <span>MGAs</span>
            </a>
            <a
              class="nav-item sub-item"
              [class.mapping-expanded]="mappingExpanded"
              (click)="toggleMapping($event)"
              tabindex="0"
              (keydown.enter)="toggleMapping($event)"
              (keydown.space)="toggleMapping($event)"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
              <span>Mapping</span>
              <svg lucideChevronDown class="arrow-icon" style="margin-left: auto"></svg>
            </a>
            <div class="nav-nested-sub-items" [class.expanded]="mappingExpanded">
              <a
                class="nav-item sub-item nested-item"
                routerLink="/masters"
                [queryParams]="{ tab: 'products' }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
              >
                <svg
                  class="sub-nav-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="3" />
                  <path
                    d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
                  />
                </svg>
                <span>COB to Coverage</span>
              </a>
            </div>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'reinsurers' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>Reinsurers</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'states' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
              <span>States</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'tpas' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg lucideUsers class="sub-nav-icon"></svg>
              <span>TPAs</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'treaty-types' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <line x1="9" y1="9" x2="15" y2="9" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="13" y2="17" />
              </svg>
              <span>Treaty Types</span>
            </a>
            <a
              class="nav-item sub-item"
              routerLink="/masters"
              [queryParams]="{ tab: 'rule-engine' }"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ queryParams: 'exact', exact: false }"
            >
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="3" />
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
                />
              </svg>
              <span>Rule Engine</span>
            </a>
          </div>
        </div>
      }

      <!-- 4. System Admin (collapsible, wrapping User Management) -->
      @if (hasPermission("user", "view") || hasPermission("role", "view") || hasPermission("activity_log", "view")) {
        <div class="nav-item-group" [class.expanded]="adminExpanded">
          <a
            class="nav-item group-header"
            (click)="toggleAdmin($event)"
            tabindex="0"
            (keydown.enter)="toggleAdmin($event)"
            (keydown.space)="toggleAdmin($event)"
          >
            <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="12" cy="12" r="3" />
              <path
                d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
              />
            </svg>
            <span class="nav-label">System Admin</span>
            <svg lucideChevronDown class="arrow-icon"></svg>
          </a>

          <div class="nav-sub-items">
            <a class="nav-item sub-item" routerLink="/user-management/activity-logs" routerLinkActive="active">
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span>Activity Logs</span>
            </a>
            <a class="nav-item sub-item" routerLink="/user-management/roles" routerLinkActive="active">
              <svg
                class="sub-nav-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
                />
              </svg>
              <span>Roles &amp; Permissions</span>
            </a>
            <a class="nav-item sub-item" routerLink="/user-management/users" routerLinkActive="active">
              <svg lucideUsers class="sub-nav-icon"></svg>
              <span>Users</span>
            </a>
          </div>
        </div>
      } @else {
        <div class="nav-item-group">
          <a class="nav-item group-header disabled-item">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="12" cy="12" r="3" />
              <path
                d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
              />
            </svg>
            <span class="nav-label">System Admin</span>
            <svg lucideChevronDown class="arrow-icon"></svg>
          </a>
        </div>
      }
    </div>
  </div>

  <!-- Footer Profile & Sign Out -->
  <div class="sidebar-footer">
    <div class="user-profile-info">
      <div class="user-avatar-circle">
        {{ initials }}
      </div>
      <div class="user-details">
        <span class="user-name">{{ displayName }}</span>
        <span class="user-role">{{ userRole }}</span>
      </div>
    </div>
    <button class="logout-btn" (click)="signOut($event)" title="Sign Out">
      <svg lucideLogOut></svg>
    </button>
  </div>
</nav>
